export const taxonomyMenus = () => ({
    id: `main-menu-2-all`,
    path: '/management/logistics/categories',
    label: 'Taxonomy',
    isEnabled: true,
    svg: (
        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
                <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M3 4a1 1 0 0 1 1-1h6.586L12 2.586 13.414 1.172a1 1 0 0 1 1.414 0L16 2.586 17.414 1.172a1 1 0 0 1 1.414 0L20 2.586 20.586 3H22a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4zm2 2v14h16V6H5z" />
                <path fill="#ffffff" fillRule="evenodd" clipRule="evenodd" d="M10 11a1 1 0 0 1 2 0v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 0 1-2 0v-2H8a1 1 0 1 1 0-2h2v-2z" />
            </g>
        </svg>
    ),

    Description: 'Structured framework of hierarchical classification system that organizes and categorizes data, information based on their characteristics or relationships, enabling easier retrieval and analysis.',
    subMenu: [
        {
            id: `coln-1-collections`,
            label: 'Categories',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="6" y="28" width="36" height="14" rx="4" fill="#007BFF" stroke-width="4"></rect>
                    <path d="M20 7H10C7.79086 7 6 8.79086 6 11V17C6 19.2091 7.79086 21 10 21H20" fill="#007BFF" stroke-width="4" stroke-linecap="round"></path>
                    <circle cx="34" cy="14" r="8" fill="#007BFF" stroke-width="4"></circle>
                    <circle cx="34" cy="14" r="3" fill="#007BFF"></circle>
                </svg>

            ),
            path: '/management/logistics/categories',
            isEnabled: true,

        },
        {
            id: `coln-1-collections`,
            label: 'ProductTypes',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M17 8h1v11H2V8h1V6c0-2.76 2.24-5 5-5 .71 0 1.39.15 2 .42.61-.27 1.29-.42 2-.42 2.76 0 5 2.24 5 5v2zM5 6v2h2V6c0-1.13.39-2.16 1.02-3H8C6.35 3 5 4.35 5 6zm10 2V6c0-1.65-1.35-3-3-3h-.02c.63.84 1.02 1.87 1.02 3v2h2zm-5-4.22C9.39 4.33 9 5.12 9 6v2h2V6c0-.88-.39-1.67-1-2.22z" fill="#007BFF"></path>
                </svg>

            ),
            path: '/management/logistics/product-types',
            isEnabled: true,

        },
        {
            id: `coln-1-collections`,
            label: 'Products',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M17 8h1v11H2V8h1V6c0-2.76 2.24-5 5-5 .71 0 1.39.15 2 .42.61-.27 1.29-.42 2-.42 2.76 0 5 2.24 5 5v2zM5 6v2h2V6c0-1.13.39-2.16 1.02-3H8C6.35 3 5 4.35 5 6zm10 2V6c0-1.65-1.35-3-3-3h-.02c.63.84 1.02 1.87 1.02 3v2h2zm-5-4.22C9.39 4.33 9 5.12 9 6v2h2V6c0-.88-.39-1.67-1-2.22z" fill="#007BFF"></path>
                </svg>

            ),
            path: '/management/logistics/products',
            isEnabled: true,

        },
        {
            id: `coln-1-collections`,
            label: 'Variants',
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#007BFF" d="M12 2c1.1 0 2 .9 2 2h3v2h-3.18C13.4 8.17 12 11 12 11s-1.4-2.83-1.82-5H7V4h3c0-1.1.9-2 2-2zm7 10c0-1.1.9-2 2-2v3h-2v-1zm0 4h2v1c0 1.1-.9 2-2 2v-3zm-4 4c-1.1 0-2-.9-2-2h-3v-2h3.18c.42 2.17 1.82 5 1.82 5s1.4-2.83 1.82-5H17v2h-3c0 1.1-.9 2-2 2zm-4-4h-3v-1c0-1.1-.9-2-2-2v3h2v1c0 1.1.9 2 2 2v-3zm-7-8c1.1 0 2 .9 2 2H4v-2h3V6H4c-1.1 0-2 .9-2 2v2zm2-4h3V6H4v3z" />
                </svg>

            ),
            path: '/management/logistics/variants',
            isEnabled: true,

        },
    ],
}
)
